import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Icon from 'components/Icon'

import classes from './PaginationItem.module.scss'

const renderPageElement = (page, type) => {
  switch (type) {
    case 'previous':
      return <Icon icon="navigate-previous" prefix="fas" className={classes.navigationIcon} />
    case 'next':
      return <Icon icon="navigate-next" prefix="fas" className={classes.navigationIcon} />
    case 'start-ellipsis':
    case 'end-ellipsis':
      return '...'
    default:
      return page
  }
}

const getLabel = (page, type) => {
  if (type === 'page') {
    return `Go to page ${page}`
  }
  if (type === 'previous' || type === 'next') {
    return `Go to ${type} page`
  }
  return ''
}

const getTestId = type => {
  if (type === 'page') {
    return `pagination-item-number`
  }
  if (type === 'previous' || type === 'next') {
    return `pagination-item-${type}`
  }
  return ''
}

/** @type {import("./types").default} */
const PaginationItem = ({ page, type, selected, disabled, shape, color, size }) => {
  const isPage = type === 'page'

  return (
    <Button
      disabled={disabled}
      data-testid={getTestId(type)}
      aria-label={getLabel(page, type)}
      className={clsx(
        // classes comes from scss, classNames comes from the parent component
        'PaginationItem',
        classes.root,
        classes[color],
        classes[size],
        classes[shape],
        {
          [classes.selected]: selected,
          [classes.disabled]: disabled,
        }
      )}
    >
      <div className={clsx(classes.item, { [classes.page]: isPage })}>{renderPageElement(page, type)}</div>
    </Button>
  )
}

export default PaginationItem
